import React, { useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';

import { firstNum } from 'utils';

const NewLunches = ({ classes, state, setState }) => {
  const [text, setText] = useState(firstNum([state.quantityPreferences.newLunchCount, state.quantityPreferences.lunchCount, 4]));
  const lunchCount = firstNum([state.quantityPreferences.lunchCount, 4]);

  useEffect(() => {
    const newLunchCount = firstNum([state.quantityPreferences.newLunchCount, state.quantityPreferences.lunchCount, 4]);
    setText(newLunchCount);
  }, [state.quantityPreferences.newLunchCount, state.quantityPreferences.lunchCount]);

  const update = (newLunchCount) => {
    setState((state) => ({
      ...state, quantityPreferences: { ...state.quantityPreferences, newLunchCount }
    }));
    setText(newLunchCount);
  };

  const handleSliderChange = (event, newLunches) => {
    update(newLunches);
  };

  const handleInputChange = (event) => {
    setText(event.target.value);
  };

  const value = Number(text);

  const handleBlur = () => {
    let newLunchCount;
    if (text === '' || isNaN(text)) {
      newLunchCount = 0;
    } else {
      newLunchCount = Number(text);
    }
    if (newLunchCount > lunchCount) {
      newLunchCount = lunchCount;
    }
    update(newLunchCount);
  };

  return (
    <Grid container item>
      <Grid item xs={1} />
      <Grid container direction="column" item xs={11}>
        <Grid item>
          <Typography id="new-lunch-count" gutterBottom className={classes.label}>
            How many <em>new</em> lunch recipes do you like to try each week?
          </Typography>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs>
            <Slider
              valueLabelDisplay="auto"
              value={value}
              onChange={handleSliderChange}
              aria-labelledby="new-lunch-count"
              step={1}
              min={0}
              max={lunchCount}
            />
          </Grid>
          <Grid item xs>
            <Input
              className={classes.input}
              value={text}
              margin="dense"
              onChange={handleInputChange}
              onBlur={handleBlur}
              inputProps={{
                step: 1,
                min: 0,
                max: lunchCount,
                type: 'number',
                'aria-labelledby': 'new-lunch-count',
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NewLunches;
